import React, {useEffect, useState, useRef} from "react";
import {
    Building2,
    Mail,
    Phone,
    MapPin,
    Landmark,
    Users,
    Globe,
    Pencil,
    X,
    HousePlus,
    Save,
    Plus,
    Trash,
} from "lucide-react";
import Cookies from "js-cookie";
import axios from "axios";
import {toast} from "react-toastify";
import {usePrivilege} from "../../../../../guard/usePrivilege";

const COMMON_TIMEZONES = [
    "US/Alaska",
    "US/Aleutian",
    "US/Arizona",
    "US/Central",
    "US/East-Indiana",
    "US/Eastern",
    "US/Hawaii",
    "US/Indiana-Starke",
    "US/Michigan",
    "US/Mountain",
    "US/Pacific",
    "US/Samoa",
    "America/Adak",
    "America/Anchorage",
    "America/Anguilla",
    "America/Antigua",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/ComodRivadavia",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Aruba",
    "America/Asuncion",
    "America/Atikokan",
    "America/Atka",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Buenos_Aires",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Catamarca",
    "America/Cayenne",
    "America/Cayman",
    "America/Chicago",
    "America/Chihuahua",
    "America/Ciudad_Juarez",
    "America/Coral_Harbour",
    "America/Cordoba",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Dominica",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Ensenada",
    "America/Fort_Nelson",
    "America/Fort_Wayne",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Godthab",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indianapolis",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Jujuy",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Knox_IN",
    "America/Kralendijk",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Louisville",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Marigot",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Mendoza",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Montreal",
    "America/Montserrat",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Nuuk",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port-au-Prince",
    "America/Port_of_Spain",
    "America/Porto_Acre",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Rosario",
    "America/Santa_Isabel",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Shiprock",
    "America/Sitka",
    "America/St_Barthelemy",
    "America/St_Johns",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Tortola",
    "America/Vancouver",
    "America/Virgin",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife"
];

const ViewPreferredPartnerDetails = ({orgData: initialOrgData}) => {
    const [orgData, setOrgData] = useState(initialOrgData);
    const [formData, setFormData] = useState(initialOrgData || {});
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [reloading, setReloading] = useState(false);
    const [contactPersons, setContactPersons] = useState([]);
    const [loadingContacts, setLoadingContacts] = useState(false);
    const [editingContactIndex, setEditingContactIndex] = useState(null);
    const [editedContact, setEditedContact] = useState(null);
    const [timezoneSearch, setTimezoneSearch] = useState("");
    const scrollRef = useRef(null);

    const token = Cookies.get("authToken");
    const userOfficeCode = Cookies.get("officeCodes");
    const [chargeTolerances, setChargeTolerances] = useState([]);
const [loadingTolerances, setLoadingTolerances] = useState(false);
const [originalChargeTolerances, setOriginalChargeTolerances] = useState([]);
const [savingTolerances, setSavingTolerances] = useState(false);
const [isEditingTolerances, setIsEditingTolerances] = useState(false);
const [editingToleranceRows, setEditingToleranceRows] = useState(new Set());
const [shippers, setShippers] = useState([]);
const [loadingShippers, setLoadingShippers] = useState(false);

const [userProfile, setUserProfile] = useState(null);
const loggedInEmail = JSON.parse(Cookies.get("userData") || "{}").email;
console.log("email user",loggedInEmail);




    const {hasPrivilege} = usePrivilege();
// Replace the canEditContacts check with these three separate privilege checks
    const canEditOrganization = hasPrivilege("organizationProfile:EDIT") &&
        userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);
    const canEditContacts = hasPrivilege("organizationProfile:editContacts") &&
        userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);
    const canRemoveContacts = hasPrivilege("organizationProfile:assignContacts") &&
        userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);


  
  const userOfficeCodes = (userOfficeCode || "")
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
  


//     const canViewTolerances =
//   hasPrivilege("organizationProfile:viewTolerances") &&
//   userOfficeCodes.includes(orgData.officeCode);

//   const canEditTolerances =
//   canViewTolerances && hasPrivilege("organizationProfile:editTolerances");

// // only show tolerances for the user’s office codes
// const visibleChargeTolerances = chargeTolerances.filter((tol) =>
//   userOfficeCodes.includes((tol?.shipperCode || "").trim())
// );

// // also restrict shipper dropdown to user office codes
// const visibleShippers = shippers.filter((s) =>
//   userOfficeCodes.includes((s?.officeCode || "").trim())
// );

const userShipperOfficeCodes = (userProfile?.organizations ?? [])
  .filter((org) => org.orgType === "Shipper")
  .map((org) => (org.officeCode || "").trim());

const userHasAdminRole = (userProfile?.roles ?? [])
  .some((role) => role.active && role.name.toLowerCase().includes("admin"));

const canViewTolerances = userShipperOfficeCodes.includes((orgData?.officeCode || "").trim());

const canEditTolerances = canViewTolerances && userHasAdminRole;

const visibleChargeTolerances = chargeTolerances.filter((tol) =>
  userShipperOfficeCodes.includes((tol?.shipperCode || "").trim())
);

const visibleShippers = shippers.filter((s) =>
  userShipperOfficeCodes.includes((s?.officeCode || "").trim())
);

const [autoApprovalConfig, setAutoApprovalConfig] = useState({});   
const [loadingAutoApproval, setLoadingAutoApproval] = useState(false);
const [savingAutoApproval, setSavingAutoApproval] = useState(null);  

    // Helper function to convert 24-hour time to 12-hour format with AM/PM
    const formatTo12Hour = (time24) => {
        if (!time24) return "—";
        const [hours, minutes] = time24.split(":");
        const hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };
    const fetchChargeTolerances = async () => {
        try {
            setLoadingTolerances(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/invoice-charges/tolerance`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const data = Array.isArray(res.data) ? res.data : [];
            setChargeTolerances(data);
            setOriginalChargeTolerances(data);
            console.log("✅ Fetched ALL charge tolerances:", data);
        } catch (err) {
            console.error("❌ Failed to fetch charge tolerances:", err);
            toast.error("Failed to fetch charge tolerances.");
        } finally {
            setLoadingTolerances(false);
        }
    };

    const fetchShippers = async () => {
        try {
          setLoadingShippers(true);
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/organizations/get-shippers`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
      
          const data = Array.isArray(res.data) ? res.data : [];
          setShippers(data);
          console.log("✅ Fetched shippers:", data);
        } catch (err) {
          console.error("❌ Failed to fetch shippers:", err);
          toast.error("Failed to fetch shippers.");
        } finally {
          setLoadingShippers(false);
        }
      };
      
      const fetchAutoApprovalConfig = async (shipperCodes = userShipperOfficeCodes) => {
        try {
          setLoadingAutoApproval(true);
          const results = {};
          await Promise.all(
            shipperCodes.map(async (code) => {
              try {
                const res = await axios.get(
                  `${process.env.REACT_APP_API_BASE_URL}/api/auto-approval-config`,
                  {
                    params: { shipper: code },
                    headers: { Authorization: `Bearer ${token}` },
                    "Office-Code": code, 
                  }
                );
                results[code] = res.data?.autoApprove ?? false;
              } catch {
                results[code] = false;
              }
            })
          );
          setAutoApprovalConfig(results);
        } catch (err) {
          console.error("❌ Failed to fetch auto-approval config:", err);
          toast.error("Failed to fetch auto-approval settings.");
        } finally {
          setLoadingAutoApproval(false);
        }
      };
      
      const handleToggleAutoApproval = async (officeCode) => {
        const current = autoApprovalConfig[officeCode] ?? false;
        const next = !current;
        setSavingAutoApproval(officeCode);
        try {
          await axios.put(
            `${process.env.REACT_APP_API_BASE_URL}/api/auto-approval-config`,
            { autoApprove: next },
            {
              params: { shipper: officeCode },
              headers: { Authorization: `Bearer ${token}` },
              "Office-Code": officeCode
            }
          );
          setAutoApprovalConfig((prev) => ({ ...prev, [officeCode]: next }));
          toast.success(`Auto-approval ${next ? "enabled" : "disabled"} for ${officeCode}.`);
        } catch (err) {
          console.error("❌ Failed to update auto-approval:", err);
          toast.error("Failed to update auto-approval setting.");
        } finally {
          setSavingAutoApproval(null);
        }
      };
 
const handleToleranceChange = (index, field, value) => {
  setChargeTolerances((prev) => {
    const current = [...prev];
    const existing = current[index];

    let row = { ...existing, [field]: value };

    // normalize
    row.shipperCode = (row.shipperCode || "").trim();
    row.chargeCode = (row.chargeCode || "").trim().toUpperCase();

    /* ----------------------------
       RESET DEPENDENT FIELDS
    -----------------------------*/
    if (field === "shipperCode") {
      row.chargeCode = "";
      row.toleranceBasis = "";
      row.toleranceValue = "";
    }

    if (field === "chargeCode") {
      row.toleranceBasis = "";
      row.toleranceValue = "";
    }

    if (field === "toleranceBasis") {
      row.toleranceValue = "";
    }

    const { shipperCode, chargeCode, toleranceBasis } = row;

    /* ----------------------------
       DUPLICATE SHIPPER + CHARGE
    -----------------------------*/
    if (shipperCode && chargeCode) {
      const hasDuplicate = current.some((tol, i) => {
        if (i === index) return false;

        return (
          (tol.shipperCode || "").trim() === shipperCode &&
          (tol.chargeCode || "").trim().toUpperCase() === chargeCode
        );
      });

      if (hasDuplicate) {
        toast.error(
          "Only one tolerance is allowed per office code and charge code."
        );
        return prev; // ⛔ reject change
      }
    }

    /* ----------------------------
       FLAT vs PERCENT CONFLICT
    -----------------------------*/
    if (shipperCode && chargeCode && toleranceBasis) {
      const hasConflict = current.some((tol, i) => {
        if (i === index) return false;

        return (
          (tol.shipperCode || "").trim() === shipperCode &&
          (tol.chargeCode || "").trim().toUpperCase() === chargeCode &&
          tol.toleranceBasis &&
          tol.toleranceBasis !== toleranceBasis
        );
      });

      if (hasConflict) {
        toast.error(
          "Cannot mix FLAT and PERCENT for the same office code & charge."
        );
        return prev; // ⛔ reject change
      }
    }

    current[index] = row;
    return current;
  });
};
      
      
      
          
      const handleAddToleranceRow = () => {
        const newIndex = chargeTolerances.length;
      
        const defaultOffice = userShipperOfficeCodes?.[0] || ""; // first office code user has
      
        setChargeTolerances((prev) => [
          ...prev,
          {
            shipperCode: defaultOffice,
            chargeCode: "",
            toleranceBasis: "",
            toleranceValue: "",
          },
        ]);
      
        setEditingToleranceRows((prev) => {
          const next = new Set(prev);
          next.add(newIndex);
          return next;
        });
      
        setIsEditingTolerances(true);
      };
      
        
      const handleSaveTolerances = async () => {
        if (!chargeTolerances || chargeTolerances.length === 0) {
          toast.info("No charge tolerances to save.");
          return;
        }

     
      
        const normalized = chargeTolerances
          .map((tol) => ({
            ...tol,
            shipperCode: (tol.shipperCode || "").trim(),
            chargeCode: (tol.chargeCode || "").trim().toUpperCase(),
          }))
          .filter((tol) => !!tol.shipperCode);
      
        const seen = new Set();

for (const tol of normalized) {
  const key = `${tol.shipperCode}||${tol.chargeCode}`;
  if (seen.has(key)) {
    toast.error(
      `Only one tolerance is allowed per Office Code & Charge Code (${tol.chargeCode}).`
    );
    return;
  }
  seen.add(key);
}
      
      
        // Existing basis validation (you can keep or remove; it's redundant but harmless now)
        const basisCountByKey = {};
      
        for (const tol of normalized) {
          const { shipperCode, chargeCode, toleranceBasis } = tol;
          if (!shipperCode || !chargeCode) continue;
      
          const key = `${shipperCode}||${chargeCode}`;
          if (!basisCountByKey[key]) basisCountByKey[key] = 0;
          if (toleranceBasis) basisCountByKey[key]++;
        }
      
        const invalidCharges = Object.entries(basisCountByKey)
          .filter(([, count]) => count > 1)
          .map(([key]) => key.split("||")[1]);
      
        if (invalidCharges.length) {
          const uniqueCharges = [...new Set(invalidCharges)];
          toast.error(
            `Only one tolerance basis is allowed per office code & charge code. Conflicting charges: ${uniqueCharges.join(", ")}`
          );
          return;
        }
      
        const groupedByShipper = normalized.reduce((acc, tol) => {
          const code = tol.shipperCode;
          if (!acc[code]) acc[code] = [];
          acc[code].push(tol);
          return acc;
        }, {});
      
        try {
          setSavingTolerances(true);
      
          const baseUrl = `${process.env.REACT_APP_API_BASE_URL}/api/invoice-charges/tolerance`;
      
          await Promise.all(
            Object.entries(groupedByShipper).map(([shipperCode, list]) =>
              axios.put(baseUrl, list, {
                params: { shipperCode },
                headers: { Authorization: `Bearer ${token}` },
              })
            )
          );
      
          toast.success("Charge tolerances updated successfully!");
          await fetchChargeTolerances();
          setEditingToleranceRows(new Set());
          setIsEditingTolerances(false);
        } catch (err) {
          console.error("❌ Failed to update charge tolerances:", err);
          toast.error("Failed to update charge tolerances.");
        } finally {
          setSavingTolerances(false);
        }
      };
      
              
      const fetchUserProfile = async () => {
        if (!loggedInEmail) return;
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/auth/user/viewprofile?userEmail=${encodeURIComponent(loggedInEmail)}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setUserProfile(res.data);
        } catch (err) {
            console.error("❌ Failed to fetch user profile:", err);
        }
    };  
    
    

    const fetchContactPersons = async (officeCode) => {
        if (!officeCode) return;
        try {
            setLoadingContacts(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/auth/user/contact-persons/${officeCode}`,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            const raw = Array.isArray(res.data) ? res.data : [res.data];
            const cleaned = raw.filter(c => c && typeof c === "object"); // prevent null entries
            setContactPersons(cleaned);
            console.log("✅ Fetched contact persons (cleaned):", cleaned);
        } catch (err) {
            console.error("❌ Failed to fetch contact persons:", err);
            toast.error("Failed to fetch contact persons.");
        } finally {
            setLoadingContacts(false);
        }
    };

    // 🔁 Fetch organization details
    const refreshOrgDetails = async () => {
        if (!initialOrgData?.org_id) return;
        try {
            setReloading(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/organizations/${initialOrgData.org_id}`,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            setOrgData(res.data);
            setFormData(res.data);
            console.log("✅ Refreshed org data:", res.data);

            if (res.data?.officeCode) {
                await fetchContactPersons(res.data.officeCode);
            }
            await fetchChargeTolerances();
            await fetchUserProfile();
            await fetchShippers();
           
let profileData = null;
try {
  const profileRes = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/auth/user/viewprofile?userEmail=${encodeURIComponent(loggedInEmail)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  profileData = profileRes.data;
  setUserProfile(profileData);
} catch (err) {
  console.error("❌ Failed to fetch user profile:", err);
}

const freshShipperCodes = (profileData?.organizations ?? [])
  .filter((org) => org.orgType === "Shipper")
  .map((org) => (org.officeCode || "").trim());

await fetchAutoApprovalConfig(freshShipperCodes);

        } catch (err) {
            console.error("❌ Failed to fetch org details:", err);
            toast.error("Failed to refresh organization details.");
        } finally {
            setReloading(false);
            setLoading(false);
        }
    };

    // 💾 Save organization updates
    const handleSave = async () => {
        try {
            setLoading(true);
            await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/organizations/${orgData.org_id}`,
                formData,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            console.log("✅ Updated org data:", formData);
            toast.success("Organization updated successfully!");
            setIsEditing(false);
            await refreshOrgDetails();
        } catch (err) {
            console.error("❌ Failed to update organization:", err);
            toast.error("Failed to update organization.");
        } finally {
            setLoading(false);
        }
    };

    // ✏️ Start editing contact
    const handleEditContact = async (index) => {
        const original = contactPersons[index];
        if (!original) {
            toast.error("Invalid contact record.");
            return;
        }
        setEditingContactIndex(index);
        const contactData = {...original};
        try {
            const timezoneRes = await axios.get('http://worldtimeapi.org/api/ip');
            const timezone = timezoneRes.data?.timezone || "US/Eastern";
            contactData.startWorkingHoursZone = contactData.startWorkingHoursZone || timezone;
            contactData.endWorkingHoursZone = contactData.endWorkingHoursZone || timezone;
        } catch {
            contactData.startWorkingHoursZone = contactData.startWorkingHoursZone || "US/Eastern";
            contactData.endWorkingHoursZone = contactData.endWorkingHoursZone || "US/Eastern";
        }
        setEditedContact(contactData);
        setTimezoneSearch("");
    };

    // 💾 Save contact updates
    const handleSaveContact = async () => {
        if (!editedContact) return;
        try {
            setLoadingContacts(true);
            const email = encodeURIComponent(editedContact.email);
            await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/auth/user/contact-persons/${email}`,
                editedContact,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            toast.success("Contact person updated successfully!");
            setEditingContactIndex(null);
            setEditedContact(null);
            await fetchContactPersons(orgData.officeCode);
        } catch (err) {
            console.error("❌ Failed to update contact person:", err);
            toast.error("Failed to update contact person.");
        } finally {
            setLoadingContacts(false);
        }
    };

    // ❌ Cancel contact editing
    const handleCancelContactEdit = () => {
        setEditingContactIndex(null);
        setEditedContact(null);
    };

    // 🗑️ Remove contact person
    const handleRemoveContactPerson = async (contact) => {
        try {
            setLoadingContacts(true);
            const email = encodeURIComponent(contact.email);
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/auth/user/contact-persons/${email}/toggle?showOnOrgProfile=false`,
                {},
                {headers: {Authorization: `Bearer ${token}`}}
            );
            toast.success("Contact person removed successfully!");
            await fetchContactPersons(orgData.officeCode);
        } catch (err) {
            console.error("❌ Failed to remove contact person:", err);
            toast.error("Failed to remove contact person.");
        } finally {
            setLoadingContacts(false);
        }
    };

    const formatPhoneNumberForDisplay = (rawValue) => {
        if (!rawValue) return "";
        const digitsOnly = rawValue.replace(/\D/g, "");
        if (!digitsOnly) return "";

        if (digitsOnly.length <= 10) {
            const area = digitsOnly.slice(0, 3);
            const mid = digitsOnly.slice(3, 6);
            const end = digitsOnly.slice(6);
            if (digitsOnly.length <= 6) return `(${area}) ${mid}`.trim();
            return `(${area}) ${mid}${end ? `-${end}` : ""}`.trim();
        }

        const country = digitsOnly.slice(0, digitsOnly.length - 10);
        const area = digitsOnly.slice(-10, -7);
        const mid = digitsOnly.slice(-7, -4);
        const end = digitsOnly.slice(-4);
        return `+${country} (${area}) ${mid}-${end}`;
    };

    const handlePhoneBlur = () => {
        if (!editedContact) return;
        const formatted = formatPhoneNumberForDisplay(editedContact.phoneNumber);
        setEditedContact({...editedContact, phoneNumber: formatted});
    };
    const editingChargeTolerances = chargeTolerances.filter((_, index) =>
    editingToleranceRows.has(index)
  );

    useEffect(() => {
        refreshOrgDetails();
    }, [initialOrgData?.org_id]);

    if (loading)
        return (
            <div className="flex items-center justify-center h-full text-gray-500 dark:text-acs-dark-subtext">
                Loading organization details...
            </div>
        );

    if (!orgData)
        return (
            <div className="p-6 text-gray-500 dark:text-acs-dark-subtext">
                No organization data available.
            </div>
        );

    // const canEditContacts = userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);
    // console.log("🔑 Can Edit Contacts:", canEditContacts, " | User Office Code:", userOfficeCode, " | Org Office Code:", orgData.officeCode);
    return (
        <div
            ref={scrollRef}
            className="w-full h-full flex flex-col transition-opacity duration-500 bg-gray-50 dark:bg-acs-dark-bg"
        >
            {/* === Top Header === */}
            <div
                className="sticky top-0 z-10 bg-white dark:bg-acs-dark-surface shadow-md p-fluid-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-fluid-3">
                <div className="flex items-center gap-fluid-3">
                    <div
                        className="w-20 h-20 rounded-full bg-acs-accent/20 dark:bg-acs-accent/30 flex items-center justify-center shadow-inner">
                        <Building2 className="w-10 h-10 text-blue-600 dark:text-acs-accent"/>
                    </div>
                    <div>
                        <h2 className="text-fluid-xl font-semibold text-gray-900 dark:text-acs-dark-text">
                            {orgData.name || "Untitled Organization"}
                        </h2>
                        <p className="text-sm text-gray-500 dark:text-acs-dark-subtext">
                            Office Code: {orgData.officeCode || "—"}
                        </p>
                    </div>
                </div>
            </div>

            {/* === Main Content === */}
            <div className="flex-1 overflow-y-auto bg-white dark:bg-acs-dark-bg w-full p-fluid-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-fluid-3 mb-fluid-3">
                    {/* LEFT COLUMN */}
                    <div className="space-y-fluid-3">
                        {/* === Organization Info === */}
                        <div
                            className={`bg-gray-50 dark:bg-acs-dark-surface border border-gray-100 dark:border-acs-dark-border rounded-xl shadow-sm p-fluid-3 ${
                                isEditing ? "ring-2 ring-indigo-300 dark:ring-acs-accent" : ""
                            }`}
                        >
                            <div className="flex items-center justify-between mb-fluid-2">
                                <h3 className="text-fluid-lg font-semibold text-gray-900 dark:text-acs-dark-text">
                                    Organization Information
                                </h3>
                                <button
                                    onClick={() => {
                                        if (!canEditOrganization) return;
                                        setIsEditing((prev) => !prev);
                                    }}
                                    className={`p-2 rounded-full transition ${canEditOrganization ? 'hover:bg-gray-100 dark:hover:bg-[#2A2D35]' : 'opacity-50 cursor-not-allowed'}`}
                                    title={
                                        canEditOrganization
                                            ? (isEditing ? "Cancel Editing" : "Edit Organization")
                                            : "You do not have permission to edit"
                                    }
                                    disabled={!canEditOrganization}
                                >
                                    {canEditOrganization && (
                                        isEditing ? (
                                            <X className="w-5 h-5 text-gray-500 dark:text-acs-dark-subtext"/>
                                        ) : (
                                            <Pencil className="w-5 h-5 text-gray-500 dark:text-acs-accent"/>
                                        )
                                    )}
                                </button>
                            </div>

                            {isEditing ? (
                                <div className="space-y-3 text-sm text-gray-700 dark:text-acs-dark-text">
                                    {[
                                        {
                                            key: "name",
                                            label: "Name",
                                            icon: <Building2 className="w-4 h-4 text-gray-400"/>
                                        },
                                        {
                                            key: "phone",
                                            label: "Phone",
                                            icon: <Phone className="w-4 h-4 text-gray-400"/>
                                        },
                                        {key: "email", label: "Email", icon: <Mail className="w-4 h-4 text-gray-400"/>},
                                        {
                                            key: "department",
                                            label: "Department",
                                            icon: <Landmark className="w-4 h-4 text-gray-400"/>
                                        },
                                        {
                                            key: "teamSize",
                                            label: "Team Size",
                                            icon: <Users className="w-4 h-4 text-gray-400"/>
                                        },
                                        {
                                            key: "previousSystem",
                                            label: "Previous System",
                                            icon: <Globe className="w-4 h-4 text-gray-400"/>
                                        },
                                    ].map(({key, label, icon}) => (
                                        <div key={key}>
                                            <label
                                                className="flex items-center gap-2 text-xs font-medium text-gray-500 dark:text-acs-dark-subtext mb-1">
                                                {icon} {label}
                                            </label>
                                            <input
                                                type="text"
                                                value={formData[key] || ""}
                                                onChange={(e) => setFormData((prev) => ({
                                                    ...prev,
                                                    [key]: e.target.value
                                                }))}
                                                className="w-full border border-gray-300 dark:border-acs-dark-border rounded-md p-2 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text focus:ring-2 focus:ring-indigo-400 dark:focus:ring-acs-accent focus:outline-none"
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="space-y-3 text-fluid-base text-gray-700 dark:text-acs-dark-text">
                                    {[
                                        {
                                            key: "name",
                                            label: "Name",
                                            icon: <Building2 className="w-4 h-4 text-gray-400"/>
                                        },
                                        {
                                            key: "phone",
                                            label: "Phone",
                                            icon: <Phone className="w-4 h-4 text-gray-400"/>
                                        },
                                        {key: "email", label: "Email", icon: <Mail className="w-4 h-4 text-gray-400"/>},
                                        {
                                            key: "department",
                                            label: "Department",
                                            icon: <Landmark className="w-4 h-4 text-gray-400"/>
                                        },
                                        {
                                            key: "teamSize",
                                            label: "Team Size",
                                            icon: <Users className="w-4 h-4 text-gray-400"/>
                                        },
                                        {
                                            key: "previousSystem",
                                            label: "Previous System",
                                            icon: <Globe className="w-4 h-4 text-gray-400"/>
                                        },
                                    ].map(({key, label, icon}) => (
                                        <div key={key} className="flex items-center gap-2">
                                            {icon}
                                            <p>
                        <span className="font-medium text-gray-600 dark:text-acs-dark-subtext capitalize">
                          {label}:
                        </span>{" "}
                                                {orgData[key] || "—"}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {isEditing && (
                                <div className="flex justify-end gap-3 pt-3">
                                    <button
                                        onClick={() => {
                                            setIsEditing(false);
                                            setFormData(orgData);
                                        }}
                                        className="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-acs-dark-border hover:bg-gray-100 dark:hover:bg-acs-dark-hover"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSave}
                                        className="px-4 py-2 text-sm rounded-md bg-indigo-600 dark:bg-acs-accent text-white hover:bg-indigo-700 dark:hover:bg-acs-accent/80"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            )}
                        </div>

                        {orgData.location?.calendar && (
                            <div
                                className="bg-gray-50 dark:bg-acs-dark-surface border border-gray-100 dark:border-acs-dark-border rounded-xl shadow-sm p-fluid-3">
                                <h3 className="text-fluid-lg font-semibold mb-fluid-2 text-gray-900 dark:text-acs-dark-text">
                                    Calendar
                                </h3>
                                <div className="text-sm text-gray-700 dark:text-acs-dark-text space-y-1">
                                    <p>Max Capacity: {orgData.location.calendar.maxCapacity}</p>
                                    <p>Appointment Duration: {orgData.location.calendar.appointmentDuration} hrs</p>
                                </div>
                            </div>
                        )}
                           {/* === Auto Approval === */}
                           {canViewTolerances && (
                          <div className="bg-gray-50 dark:bg-acs-dark-surface border border-gray-100 dark:border-acs-dark-border rounded-xl shadow-sm p-fluid-3">
                            <div className="flex items-center justify-between mb-fluid-2">
  <div>
    <h3 className="text-fluid-lg font-semibold text-gray-900 dark:text-acs-dark-text">
      Invoice Auto Approval
    </h3>
    {userShipperOfficeCodes.some((c) => autoApprovalConfig[c]) && (
      <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">
        Invoices with no discrepancies will be automatically approved.
      </p>
    )}
  </div>
</div>
                            {loadingAutoApproval ? (
                              <div className="flex items-center justify-center py-6">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent" />
                              </div>
                            ) : userShipperOfficeCodes.length === 0 ? (
                              <p className="text-sm text-gray-500 dark:text-acs-dark-subtext">No shipper office codes found.</p>
                            ) : (
                              <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border text-sm">
                                  <thead className="bg-gray-100 dark:bg-[#2A2D35]">
                                    <tr>
                                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Office Code</th>
                                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Auto Approval</th>
                                    </tr>
                                  </thead>
                                  <tbody className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
                                  {userShipperOfficeCodes.map((code) => {
  const isEnabled = autoApprovalConfig[code] ?? false;
  const isSaving = savingAutoApproval === code;
  
  return (
    <tr key={code}>
      <td className="px-3 py-2 text-gray-900 dark:text-acs-dark-text">
        <div className="flex items-center gap-2">
          <span>{code}</span>
        
        </div>
      </td>
      <td className="px-3 py-2">
        {canEditTolerances ? (
          <button
            type="button"
            onClick={() => handleToggleAutoApproval(code)}
            disabled={isSaving}
            className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed ${isEnabled ? "bg-indigo-600 dark:bg-acs-accent" : "bg-gray-300 dark:bg-gray-600"}`}
          >
            <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${isEnabled ? "translate-x-5" : "translate-x-0"}`} />
            {isSaving && (
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="animate-spin h-3 w-3 rounded-full border-b border-white" />
              </span>
            )}
          </button>
        ) : (
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${isEnabled ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400" : "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400"}`}>
            {isEnabled ? "Enabled" : "Disabled"}
          </span>
        )}
      </td>
    </tr>
  );
})}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        )}

                    </div>  {/* end left column */}
               

                    {/* RIGHT COLUMN */}
                    <div className="space-y-fluid-3">
                        {/* === Location Info === */}
                        <div
                            className="bg-gray-50 dark:bg-acs-dark-surface border border-gray-100 dark:border-acs-dark-border rounded-xl shadow-sm p-fluid-3">
                            <h3 className="text-fluid-lg font-semibold mb-fluid-2 text-gray-900 dark:text-acs-dark-text">
                                Location Information
                            </h3>
                            {orgData.location ? (
                                <div className="space-y-3 text-fluid-base text-gray-700 dark:text-acs-dark-text">
                                    <div className="flex items-center gap-2">
                                        <MapPin className="w-4 h-4 text-gray-400 dark:text-gray-500"/>
                                        <p>
                      <span className="font-medium text-gray-600 dark:text-acs-dark-subtext">
                        Address:
                      </span>{" "}
                                            {orgData.location.addressLine1 || "—"}
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Globe className="w-4 h-4 text-gray-400 dark:text-gray-500"/>
                                        <p>
                      <span className="font-medium text-gray-600 dark:text-acs-dark-subtext">
                        City / State:
                      </span>{" "}
                                            {orgData.location.city}, {orgData.location.state} {orgData.location.zipCode}
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Building2 className="w-4 h-4 text-gray-400 dark:text-gray-500"/>
                                        <p>
                      <span className="font-medium text-gray-600 dark:text-acs-dark-subtext">
                        Country:
                      </span>{" "}
                                            {orgData.location.country}
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <HousePlus className="w-4 h-4 text-gray-400 dark:text-gray-500"/>
                                        <p>
                      <span className="font-medium text-gray-600 dark:text-acs-dark-subtext">
                        Location Code:
                      </span>{" "}
                                            {orgData.location.locationCode}
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <p className="text-gray-500 dark:text-acs-dark-subtext">
                                    No location data available.
                                </p>
                            )}
                        </div>

{/* === Charge Tolerances === */}
{canViewTolerances && (
<div className="bg-gray-50 dark:bg-acs-dark-surface border border-gray-100 dark:border-acs-dark-border rounded-xl shadow-sm p-fluid-3">
  {/* Header row */}
  <div className="flex items-center justify-between mb-fluid-2">
    <h3 className="text-fluid-lg font-semibold text-gray-900 dark:text-acs-dark-text">
      Charge Tolerances
    </h3>

    {canEditTolerances && (
      <div className="flex items-center gap-2">
        {/* Edit toggle */}
        <button
  type="button"
  onClick={() => {
    if (!isEditingTolerances) {
      setOriginalChargeTolerances(chargeTolerances);
  
      // only enable editing for rows user can see (their shipper codes)
      const visibleIndices = new Set(
        chargeTolerances
          .map((tol, i) => ({ tol, i }))
          .filter(({ tol }) => userShipperOfficeCodes.includes((tol?.shipperCode || "").trim()))

          .map(({ i }) => i)
      );
  
      setEditingToleranceRows(visibleIndices);
      setIsEditingTolerances(true);
    } else {
      setChargeTolerances(originalChargeTolerances);
      setEditingToleranceRows(new Set());
      setIsEditingTolerances(false);
    }
  }}
  className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-[#2A2D35] transition"
  title={isEditingTolerances ? "Cancel Editing" : "Edit Charge Tolerances"}
>
  <Pencil className="w-4 h-4 text-gray-500 dark:text-acs-accent" />
</button>

        {/* Add Row */}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation(); 
            handleAddToleranceRow();
          }}
          disabled={loadingTolerances}
          className="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 dark:border-acs-dark-border bg-white dark:bg-[#2A2D35] text-gray-700 dark:text-acs-dark-text hover:bg-gray-100 dark:hover:bg-acs-dark-hover disabled:opacity-60 disabled:cursor-not-allowed"
          title="Add new tolerance row"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add Row
        </button>

       
       
      </div>
    )}
  </div>

  {/* Body */}
  {loadingTolerances ? (
    <div className="flex items-center justify-center py-6">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent" />
    </div>
  ) : visibleChargeTolerances.length === 0 ? (
    <p className="text-sm text-gray-500 dark:text-acs-dark-subtext">
      No charge tolerances configured.
    </p>
  ) : (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border text-sm">
        <thead className="bg-gray-100 dark:bg-[#2A2D35]">
          <tr>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Office Code
            </th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Charge Code
            </th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Basis
            </th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Tolerance Value
            </th>
        
          </tr>
          
        </thead>
        <tbody className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
        {visibleChargeTolerances.map((tol) => {
  const index = chargeTolerances.findIndex((row) => row === tol);
  const isEditing = editingToleranceRows.has(index);



  return (
    <tr key={tol.id ?? index}>
      <td className="px-3 py-2 text-gray-900 dark:text-acs-dark-text">
  {isEditing ? (
    <select
      value={tol.shipperCode ?? ""}
      onChange={(e) => handleToleranceChange(index, "shipperCode", e.target.value)}
      className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
      disabled={loadingShippers}
    >
      <option value="">
        {loadingShippers ? "Loading shippers..." : "Select Office"}
      </option>
      {visibleShippers.map((shipper) => (        <option key={shipper.officeCode} value={shipper.officeCode}>
          {shipper.officeCode} {shipper.name ? `- ${shipper.name}` : ""}
        </option>
      ))}
    </select>
  ) : (
    <span>{tol.shipperCode || "—"}</span>
  )}
</td>

      <td className="px-3 py-2 text-gray-900 dark:text-acs-dark-text">
        {isEditing ? (  // ← Use isEditing instead of isEditingTolerances
        <select
        value={tol.chargeCode ?? ""}
        disabled={!tol.shipperCode?.trim()}
        onChange={(e) => handleToleranceChange(index, "chargeCode", e.target.value)}
      >
            <option value="">Select</option>
            <option value="BASE">BASE</option>
            <option value="FSC">FSC</option>
          </select>
        ) : (
          <span>{tol.chargeCode || "—"}</span>
        )}
      </td>
      <td className="px-3 py-2">
        {isEditing ? (  
         <select
         value={tol.toleranceBasis ?? ""}
         disabled={!tol.chargeCode?.trim()}
         onChange={(e) => handleToleranceChange(index, "toleranceBasis", e.target.value)}
       >
            <option value="">Select</option>
            <option value="FLAT">FLAT</option>
            <option value="PERCENT">PERCENT</option>
          </select>
        ) : (
          <span className="text-gray-900 dark:text-acs-dark-text">{tol.toleranceBasis ?? "—"}</span>
        )}
        
      </td>
      <td className="px-3 py-2">
        {isEditing ? (  
        <input
        type="number"
        value={tol.toleranceValue ?? ""}
        disabled={!tol.toleranceBasis}
        onChange={(e) => handleToleranceChange(index, "toleranceValue", e.target.value)}
      />
        ) : (
          <span className="text-gray-900 dark:text-acs-dark-text">{tol.toleranceValue ?? "—"}</span>
        )}
      </td>
    </tr>
  );
})}

</tbody>
      </table>
      
      {/* Move Save/Cancel buttons HERE - after table closes */}
      {canEditTolerances && editingToleranceRows.size > 0 && (
        <div className="flex justify-end gap-3 pt-3 mt-3 border-t border-gray-200 dark:border-acs-dark-border">
          <button
            type="button"
            onClick={() => {
              setEditingToleranceRows(new Set());
              setChargeTolerances(originalChargeTolerances);
              setIsEditingTolerances(false); 
            }}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-acs-dark-border hover:bg-gray-100 dark:hover:bg-acs-dark-hover text-gray-700 dark:text-acs-dark-text"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSaveTolerances}
            disabled={
                savingTolerances ||
                loadingTolerances ||
                editingChargeTolerances.some(
                    (t) => !t.shipperCode?.trim() || !t.chargeCode?.trim()
                  )
              }
            className="px-4 py-2 text-sm rounded-md bg-indigo-600 dark:bg-acs-accent text-white hover:bg-indigo-700 dark:hover:bg-acs-accent/80 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {savingTolerances ? "Saving..." : "Save"}
          </button>
        </div>
      )}
    </div>
  )}
</div>

)}
                    </div>
                </div>

          

                {/* === Contact Persons (Full Width Bottom) === */}
                <div
                    className="bg-gray-50 dark:bg-acs-dark-surface border border-gray-100 dark:border-acs-dark-border rounded-xl shadow-sm p-fluid-3">
                    <h3 className="text-fluid-lg font-semibold mb-fluid-2 text-gray-900 dark:text-acs-dark-text">
                        Contact Persons
                    </h3>

                    {loadingContacts ? (
                        <div className="flex items-center justify-center py-8">
                            <div
                                className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent"></div>
                        </div>
                    ) : contactPersons.length > 0 ? (
                        <div className={`
                                    overflow-x-auto
                                    ${contactPersons.length >= 5 ? "max-h-[500px] overflow-y-auto" : ""}
                                `}>
                            <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border">
                                <thead className="bg-gray-100 dark:bg-[#2A2D35]">
                                <tr>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        First Name
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Last Name
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Phone
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Email
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Working Hours
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Notes
                                    </th>
                                    {(canEditContacts || canRemoveContacts) && (
                                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                            Actions
                                        </th>
                                    )}
                                </tr>
                                </thead>
                                <tbody
                                    className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
                                {contactPersons.filter(Boolean).map((contact, index) => (
                                    <tr key={contact.email || index}>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <input
                                                    type="text"
                                                    value={editedContact?.firstName || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({...editedContact, firstName: e.target.value})
                                                    }
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                />
                                            ) : (
                                                contact?.firstName || "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <input
                                                    type="text"
                                                    value={editedContact?.lastName || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({...editedContact, lastName: e.target.value})
                                                    }
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                />
                                            ) : (
                                                contact?.lastName || "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <input
                                                    type="text"
                                                    value={editedContact?.phoneNumber || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({
                                                            ...editedContact,
                                                            phoneNumber: e.target.value
                                                        })
                                                    }
                                                    onBlur={handlePhoneBlur}
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                />
                                            ) : (
                                                contact?.phoneNumber || "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {contact?.email || "—"}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <div className="space-y-2">
                                                    <div className="flex items-center gap-2">
                                                        <input
                                                            type="time"
                                                            value={editedContact?.startWorkingHours || ""}
                                                            onChange={(e) =>
                                                                setEditedContact({
                                                                    ...editedContact,
                                                                    startWorkingHours: e.target.value
                                                                })
                                                            }
                                                            className="border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                        />
                                                        <span>to</span>
                                                        <input
                                                            type="time"
                                                            value={editedContact?.endWorkingHours || ""}
                                                            onChange={(e) =>
                                                                setEditedContact({
                                                                    ...editedContact,
                                                                    endWorkingHours: e.target.value
                                                                })
                                                            }
                                                            className="border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                        />
                                                    </div>
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            value={timezoneSearch || editedContact?.startWorkingHoursZone || ""}
                                                            onChange={(e) => setTimezoneSearch(e.target.value)}
                                                            onBlur={() => {
                                                                if (timezoneSearch && COMMON_TIMEZONES.includes(timezoneSearch)) {
                                                                    setEditedContact({
                                                                        ...editedContact,
                                                                        startWorkingHoursZone: timezoneSearch,
                                                                        endWorkingHoursZone: timezoneSearch
                                                                    });
                                                                }
                                                            }}
                                                            placeholder="Search timezone..."
                                                            className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                        />
                                                        {timezoneSearch && (
                                                            <div
                                                                className="absolute z-10 w-full mt-1 max-h-40 overflow-y-auto bg-white dark:bg-[#2A2D35] border border-gray-300 dark:border-acs-dark-border rounded shadow-lg">
                                                                {COMMON_TIMEZONES.filter(tz =>
                                                                    tz.toLowerCase().includes(timezoneSearch.toLowerCase())
                                                                ).map((tz, i) => (
                                                                    <div
                                                                        key={i}
                                                                        onClick={() => {
                                                                            setEditedContact({
                                                                                ...editedContact,
                                                                                startWorkingHoursZone: tz,
                                                                                endWorkingHoursZone: tz
                                                                            });
                                                                            setTimezoneSearch("");
                                                                        }}
                                                                        className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm"
                                                                    >
                                                                        {tz}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                contact?.startWorkingHours && contact?.endWorkingHours ? (
                                                    <div>
                                                        <div>{formatTo12Hour(contact.startWorkingHours)} - {formatTo12Hour(contact.endWorkingHours)}</div>
                                                        {contact?.startWorkingHoursZone && (
                                                            <div
                                                                className="text-xs text-gray-500 dark:text-acs-dark-subtext">
                                                                {contact.startWorkingHoursZone}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <textarea
                                                    value={editedContact?.contactNotes || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({
                                                            ...editedContact,
                                                            contactNotes: e.target.value
                                                        })
                                                    }
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                    rows="2"
                                                />
                                            ) : (
                                                contact?.contactNotes || "—"
                                            )}
                                        </td>
                                        {(canEditContacts || canRemoveContacts) && (
                                            <td className="px-3 py-3 text-sm">
                                                {editingContactIndex === index ? (
                                                    <div className="flex gap-2">
                                                        {canEditContacts && (
                                                            <>
                                                                <button
                                                                    onClick={handleSaveContact}
                                                                    className="p-1 rounded hover:bg-green-100 dark:hover:bg-green-900/30"
                                                                    title="Save"
                                                                >
                                                                    <Save
                                                                        className="w-4 h-4 text-green-600 dark:text-green-400"/>
                                                                </button>
                                                                <button
                                                                    onClick={handleCancelContactEdit}
                                                                    className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30"
                                                                    title="Cancel"
                                                                >
                                                                    <X className="w-4 h-4 text-red-600 dark:text-red-400"/>
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="flex gap-2">
                                                        {canEditContacts && (
                                                            <button
                                                                onClick={() => handleEditContact(index)}
                                                                className="p-1 rounded hover:bg-gray-100 dark:hover:bg-[#2A2D35]"
                                                                title="Edit"
                                                            >
                                                                <Pencil
                                                                    className="w-4 h-4 text-gray-500 dark:text-acs-dark-subtext"/>
                                                            </button>
                                                        )}
                                                        {canRemoveContacts && (
                                                            <button
                                                                onClick={() => handleRemoveContactPerson(contact)}
                                                                className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30"
                                                                title="Remove"
                                                            >
                                                                <Trash
                                                                    className="w-4 h-4 text-red-600 dark:text-red-400"/>
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-gray-500 dark:text-acs-dark-subtext">
                            No contact persons available.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewPreferredPartnerDetails;
